function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { FileUploader } from 'angular-file-upload';
import { values } from 'lodash';
import { AccesoDatos, BASE_CANDIDATO_API } from 'src/_candidato/comun/services/acceso-datos';
import { DocsCV } from 'src/_candidato/data/DocsCV';
var PanelCvComponentCtrl = /*#__PURE__*/function () {
  PanelCvComponentCtrl.$inject = ["$element", "$log", "$timeout", "NotifService", "$q", "AccesoDatos", "FileUploader"];
  function PanelCvComponentCtrl($element, $log, $timeout, NotifService, $q, AccesoDatos, FileUploader) {
    _classCallCheck(this, PanelCvComponentCtrl);
    _defineProperty(this, "baseUrlApiPriv", "".concat(BASE_CANDIDATO_API, "api/priv"));
    _defineProperty(this, "permitedocs", false);
    _defineProperty(this, "verEstruct", false);
    _defineProperty(this, "historyMatch", {
      tiene: false,
      list: []
    });
    _defineProperty(this, "$loading", false);
    _defineProperty(this, "history", {
      add: {
        active: false,
        text: '',
        state: null,
        dataNotif: null,
        $loading: false
      },
      list: []
    });
    _defineProperty(this, "internaldoc", {
      add: {
        active: false,
        doc: null,
        tipo: null,
        $loading: false,
        $pristine: true
      },
      showall: false,
      docs: new DocsCV()
    });
    _defineProperty(this, "statesStoreCvList", []);
    this.$element = $element;
    this.$log = $log;
    this.$timeout = $timeout;
    this.NotifService = NotifService;
    this.$q = $q;
    this.AccesoDatos = AccesoDatos;
    this.FileUploader = FileUploader;
  }
  return _createClass(PanelCvComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      var _this$showHistory, _this$showDocs, _this$editHistory, _this$editDocs, _this$hidePrint, _this$hidePdf;
      this.$log.info('[PanelCvComponentCtrl] onInit');

      // valores por defecto
      this.showHistory = (_this$showHistory = this.showHistory) !== null && _this$showHistory !== void 0 ? _this$showHistory : true;
      this.showDocs = (_this$showDocs = this.showDocs) !== null && _this$showDocs !== void 0 ? _this$showDocs : true;
      this.editHistory = (_this$editHistory = this.editHistory) !== null && _this$editHistory !== void 0 ? _this$editHistory : true;
      this.editDocs = (_this$editDocs = this.editDocs) !== null && _this$editDocs !== void 0 ? _this$editDocs : true;
      this.hidePrint = (_this$hidePrint = this.hidePrint) !== null && _this$hidePrint !== void 0 ? _this$hidePrint : false;
      this.hidePdf = (_this$hidePdf = this.hidePdf) !== null && _this$hidePdf !== void 0 ? _this$hidePdf : false;
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(obj) {
      if (obj && obj.cv) {
        this.report = null;
        this.history.add.active = false;
        this.history.add.state = null;
        this.history.add.text = '';
        this.internaldoc.add.active = false;
        this.internaldoc.add.doc = null;
        this.internaldoc.add.tipo = null;
        if (obj.cv.currentValue) this._leerCV();
      }
      if (obj.tipos && obj.tipos.currentValue) {
        this.$log.info('----> tipos!!!');
        this.tiposDocGruposList = this.tipos.gruposDocList();
        this.statesStore = this.tipos.estadosStore();
        this.internaldoc.docs.updateTipos(this.tipos);
      }
    }
  }, {
    key: "_leerCV",
    value: function _leerCV() {
      var _this = this;
      this.permitedocs = false;
      this.$loading = true;
      this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then(function (reportResponse) {
        _this.report = reportResponse;
        _this.history.list = reportResponse.history.list;
        _this.internaldoc.docs.updateDocs(reportResponse.docs);
        _this.__initAllowedStates(_this.statesStore, reportResponse);
        _this.permitedocs = reportResponse.form.permiteDocs;
        _this.historyMatch = {
          tiene: reportResponse.coincidenciasHist.tieneMatch,
          list: values(reportResponse.coincidenciasHist.registrosHistPorPreg).map(function (r) {
            return new MatchEnHist(r);
          })
        };
        _this.$loading = false;
      });
    }
  }, {
    key: "_refreshcv",
    value: function _refreshcv() {
      this.report = null;
      this._leerCV();
    }
  }, {
    key: "_leerCVHist",
    value: function _leerCVHist(match, resp) {
      if (resp.report) {
        resp.report = null;
        return;
      }
      match.$loading = true;
      this.AccesoDatos.HistoricCurr_CLIENT.datosCvHistorico(resp.resp.cv_id_historic) //
      .then(function (reportResponse) {
        resp.report = reportResponse;
        match.$loading = false;
      });
    }
  }, {
    key: "__initAllowedStates",
    value: function __initAllowedStates(stados, reporte) {
      this.statesStoreCvList = stados.list.map(function (st) {
        return new CVState(st, reporte);
      });
    }
  }, {
    key: "newHistory",
    value: function newHistory() {
      var _this2 = this;
      this.history.add.active = !this.history.add.active;
      if (this.history.add.active) {
        this.history.add.dataNotif = {
          comite_autoriza: null,
          comite_puesto: null
        };
        this.$timeout(function () {
          ;
          _this2.$element.find('select').formSelect();
          _this2.$element.find('textarea').trigger('focus');
        }, 1);
      }
    }
  }, {
    key: "addHistory",
    value: function addHistory() {
      var _this3 = this;
      this.history.add.$loading = true;

      // validar el required
      if (this.history.add.state.st.notificar && this.history.add.state.st.estadoComite) {
        if (!this.history.add.dataNotif.comite_autoriza || !this.history.add.dataNotif.comite_puesto) {
          this.NotifService.errorMsg('Please fill all required fields');
          this.history.add.$loading = false;
          return;
        }
      }
      this.AccesoDatos.GestionCurr_CLIENT.nuevaAccionParaCV(this.cv.cv.idcv, this._generaAccion()).then(function (accionResponse) {
        // incluir la nueva acción en la lista
        _this3.history.list.unshift(accionResponse.actionitem);
        _this3.history.add.active = false;
        _this3.onUpdateAccion({
          data: accionResponse
        });
      })["finally"](function () {
        return _this3.history.add.$loading = false;
      });
    }
  }, {
    key: "_generaAccion",
    value: function _generaAccion() {
      var accion = {
        state: this.history.add.state.st.estado,
        notas: this.history.add.text,
        dataNotif: null
      };
      if (this.history.add.state.st.estadoComite) {
        accion.dataNotif = this.history.add.dataNotif;
      }
      return accion;
    }
  }, {
    key: "newInternalDoc",
    value: function newInternalDoc() {
      var _this4 = this;
      // inicializar el uploader
      if (!this.internaldoc.add.active) {
        this.internaldoc.add.doc = new CVInternalDoc(this.initFileUpload());
      }
      this.internaldoc.add.active = !this.internaldoc.add.active;
      if (this.internaldoc.add.active) this.$timeout(function () {
        _this4.internaldoc.add.$pristine = true;
        _this4.internaldoc.add.$loading = false;
        _this4.$element.find('select').formSelect();
      }, 1);
    }
  }, {
    key: "addInternalDoc",
    value: function () {
      var _addInternalDoc = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this5 = this;
        var files, url, _iterator, _step, file, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.internaldoc.add.$loading || this.internaldoc.add.$pristine)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              files = this.internaldoc.add.doc.filesEnviar();
              if (files.length) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              this.internaldoc.add.$loading = true;
              url = encodeURI("".concat(this.baseUrlApiPriv, "/_cv/cv/").concat(this.cv.cv.idcv, "/idoc"));
              _iterator = _createForOfIteratorHelper(files);
              _context.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context.n = 6;
                break;
              }
              file = _step.value;
              _context.n = 5;
              return this.enviafile(file, this.internaldoc.add.doc, url);
            case 5:
              _context.n = 4;
              break;
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              _iterator.e(_t);
            case 8:
              _context.p = 8;
              _iterator.f();
              return _context.f(8);
            case 9:
              this.$timeout(function () {
                _this5.internaldoc.add.$loading = false;
                _this5.internaldoc.add.active = false;
              }, 200);
            case 10:
              return _context.a(2);
          }
        }, _callee, this, [[3, 7, 8, 9]]);
      }));
      function addInternalDoc() {
        return _addInternalDoc.apply(this, arguments);
      }
      return addInternalDoc;
    }()
  }, {
    key: "initFileUpload",
    value: function initFileUpload() {
      var __self = this;
      var uploader = new this.FileUploader({
        // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
        //,timeout: 2000
      });

      // uploader.url = BASE_CANDIDATO_API + "api/_cv/n/abc/f"

      // FILTERS

      // a sync filter
      uploader.filters.push({
        name: 'syncFilter',
        fn: function (item /*{File|FileLikeObject}*/, options) {
          console.log('syncFilter');
          return this.queue.length < 10;
        }
      });

      // an async filter
      uploader.filters.push({
        name: 'asyncFilter',
        fn: function (item /*{File|FileLikeObject}*/, options, deferred) {
          console.log('asyncFilter');
          setTimeout(deferred.resolve, 1e3);
        }
      });

      // CALLBACKS

      uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
        console.info('onWhenAddingFileFailed', item, filter, options);
      };
      uploader.onAfterAddingFile = function (fileItem) {
        if (uploader.queue.length > 1) {
          uploader.removeFromQueue(0);
        }
        console.info('onAfterAddingFile', fileItem);
        console.info('onAfterAddingFile', uploader.queue);
        __self.$timeout(function (_) {
          __self.internaldoc.add.$pristine = false;
        });
      };
      uploader.onAfterAddingAll = function (addedFileItems) {
        console.info('onAfterAddingAll', addedFileItems);
      };
      uploader.onBeforeUploadItem = function (item) {
        console.info('onBeforeUploadItem', item);
        var f = new FormData();
        f.append('foo', '2');
        item.formData.push(f);
      };
      uploader.onProgressItem = function (fileItem, progress) {
        console.info('onProgressItem', fileItem, progress);
      };
      uploader.onProgressAll = function (progress) {
        console.info('onProgressAll', progress);
      };
      uploader.onSuccessItem = function (fileItem, response, status, headers) {
        console.info('onSuccessItem', fileItem, response, status, headers);
      };
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info('onErrorItem', fileItem, response, status, headers);
      };
      uploader.onCancelItem = function (fileItem, response, status, headers) {
        console.info('onCancelItem', fileItem, response, status, headers);
      };
      uploader.onCompleteItem = function (fileItem, response, status, headers) {
        console.info('onCompleteItem', fileItem, response, status, headers);
      };
      uploader.onCompleteAll = function () {
        console.info('onCompleteAll');
      };
      console.info('uploader', uploader);
      return uploader;
    }
  }, {
    key: "testUpload",
    value: function testUpload() {
      var _this6 = this;
      var _up = new this.FileUploader({
        // url: BASE_CANDIDATO_API + "api/_cv/n/abc/f"
        //,timeout: 2000
      });
      this.$log.debug('test uploader', _up.queue);
      _up.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f';
      var idx = 0;
      _up.queue.forEach(function (f) {
        f.onComplete = function (response, status, headers) {
          _this6.$log.debug('Complete!!!!!', status);
        };
        var fd = new FormData();
        fd.append('idx', '' + idx++);
        f.formData = [fd];
        f.url = BASE_CANDIDATO_API + 'api/_cv/n/abc/f';
        _up.uploadItem(f);
      });
    }
  }, {
    key: "enviafile",
    value: function enviafile(f, cvpreg, url) {
      var _this7 = this;
      var $p = this.$q.defer();
      f.url = url;
      f.formData = [this._formDataPreg(f, cvpreg)];
      f.onSuccess = function (response, status, headers) {
        var result = response;
        console.log('complete!!!!');

        // incluir los datos en la lista
        _this7.$timeout(function () {
          _this7.internaldoc.docs.nuevoDoc(result.item);
        });
      };
      f.onComplete = function (response, status) {
        if (status != 200) {
          _this7.NotifService.alert('Failed to save document');
        }
        $p.resolve();
      };
      f.upload();
      return $p.promise;
    }
  }, {
    key: "_formDataPreg",
    value: function _formDataPreg(f, cvpreg) {
      var _cvpreg$tipo;
      var fd = new FormData();
      fd.append('__idcv', '' + this.cv.cv.idcv);
      fd.append('name', f.file.name);
      fd.append('tipo', this.internaldoc.add.tipo);
      if (cvpreg.tipo) fd.append('tipo', (_cvpreg$tipo = cvpreg.tipo) === null || _cvpreg$tipo === void 0 ? void 0 : _cvpreg$tipo.tipo);
      return fd;
    }
  }, {
    key: "borrarDocInterna",
    value: function borrarDocInterna($grupo, $doc) {
      var _this8 = this;
      if (confirm('Please confirm you want to delete the file \n\n **** File contents cannot be recovered *** \n\n ')) {
        this.AccesoDatos.GestionCurr_CLIENT.borrarDocInterno(this.cv.cv.idcv, $doc.iddocint, {
          f: $doc.name
        }).then(function (borrarResponse) {
          if (borrarResponse) {
            _this8.internaldoc.docs.quitarDocDeGrupo($grupo, $doc);
          }
        });
      }
    }
  }]);
}();
angular.module('candidato').component('panelCv', {
  bindings: {
    cv: '<',
    tipos: '<',
    showHistory: '<',
    showDocs: '<',
    editHistory: '<',
    editDocs: '<',
    hidePrint: '<',
    hidePdf: '<',
    onUpdateAccion: '&'
  },
  controller: PanelCvComponentCtrl,
  template: require('./panel-cv.component.html')
});
export var CVInternalDoc = /*#__PURE__*/function () {
  function CVInternalDoc(_uploader) {
    _classCallCheck(this, CVInternalDoc);
    this.uploader = _uploader;
  }
  return _createClass(CVInternalDoc, [{
    key: "filesEnviar",
    value: function filesEnviar() {
      var _list = this.uploader.queue;
      if (!_list.length) {
        console.warn('No hay files para enviar!!!!');
      }
      return _list;
    }
  }]);
}();
export var CVState = /*#__PURE__*/_createClass(function CVState(st, reporte) {
  _classCallCheck(this, CVState);
  _defineProperty(this, "tieneReglas", false);
  _defineProperty(this, "permitido", false);
  _defineProperty(this, "title", '');
  this.st = st;
  var reglEstado = reporte.regld.reglasPorEstado[st.estado.estado];
  this.tieneReglas = !!(reglEstado && reglEstado.regl.length);
  this.permitido = !this.tieneReglas || reglEstado.permited;
  if (!this.permitido) {
    this.title = 'Required docs not satisfied';
    this.displayHtml = "<span title=\"".concat(this.title, "\">").concat(st.estado.texto_en, " - ").concat(st.estado.texto_es, "</span><br/><span class=\"text-sm text-muted\">(required docs not completed)</span>");

    // si el estado no está permitido, incluir no permitido
    this.displayIcon = '/candidato/images/errorc3.png';
  } else this.displayHtml = "<span title=\"".concat(this.title, "\">").concat(st.estado.texto_en, " - ").concat(st.estado.texto_es, "</span>");
});
export var MatchEnHist = /*#__PURE__*/_createClass(function MatchEnHist(data) {
  _classCallCheck(this, MatchEnHist);
  _defineProperty(this, "$loading", false);
  this.data = data;
  this.resplist = data.regs.map(function (resp) {
    return {
      resp: resp
    };
  });
});